import Splide from '@splidejs/splide';

(function (Drupal) {

  Drupal.behaviors.globalSplide = {
    attach(context) {

      const LG_BREAKPOINT = 992;
      const MOBILE_ONLY_CLASS = 'js-splide--mobile-only';

      const baseOptions = {
        type: 'slide',
        gap: '32px',
        pagination: false,
        arrows: true,
      };

      const sliderTypes = {

        'splide--1': {
          perPage: 1,
        },

        'splide--2-1': {
          perPage: 2,
          breakpoints: {
            1200: { perPage: 1 }, 
            768: { perPage: 1 },
          }
        },

        'splide--1-5': {
          perPage: 1,
          padding: { right: '25%' },
          gap: '32px',
        },

        'splide--vertical-2-1': {
          direction: 'ttb',
          height: '600px',
          perPage: 2,
          breakpoints: {
            768: {
              direction: 'ltr',
              height: 'auto',
              perPage: 1,
            }
          }
        }

      };

      const sliders = context.querySelectorAll('.js-splide');

      sliders.forEach((el) => {

        if (el.dataset.splideProcessed) return;

        let splideInstance = null;

        function mountSlider() {

          let options = { ...baseOptions };

          for (const typeClass of Object.keys(sliderTypes)) {
            if (el.classList.contains(typeClass)) {
              options = { ...options, ...sliderTypes[typeClass] };
              break;
            }
          }

          splideInstance = new Splide(el, options);

          splideInstance.on('mounted resized', () => {

            const totalSlides = splideInstance.length;
            const perPage = splideInstance.options.perPage;
            const arrowsWrapper = el.querySelector('.splide__arrows');

            if (!arrowsWrapper) return;

            arrowsWrapper.style.display =
              totalSlides <= perPage ? 'none' : '';
          });

          splideInstance.mount();
        }

        function initOrDestroy() {

          const isMobileOnly = el.classList.contains(MOBILE_ONLY_CLASS);

          //  SOLO controlamos si tiene la clase special
          if (isMobileOnly) {

            if (window.innerWidth < LG_BREAKPOINT) {
              if (!splideInstance) mountSlider();
            } else {
              if (splideInstance) {
                splideInstance.destroy(true);
                splideInstance = null;
              }
            }

          } else {
            // comportamiento normal (siempre activo)
            if (!splideInstance) mountSlider();
          }
        }

        initOrDestroy();
        window.addEventListener('resize', initOrDestroy);

        el.dataset.splideProcessed = 'true';
      });

    }
  };

})(Drupal);